export const MAN_POWER_GET_ACTION = 'MAN_POWER_GET_ACTION'
export const MAN_POWER_GET_SUCCESS = 'MAN_POWER_GET_SUCCESS'

export const MAN_POWER_REPORT_API_ERROR_ACTION = 'MAN_POWER_REPORT_API_ERROR_ACTION'